import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Switch from '@ls/react-switch';
import { selectSelectedIsDisplayRgl } from 'state/selections/selectors';
import SelectionState from 'state/selections/SelectionState';
import { setIsDisplayRgl } from 'state/selections/actions';

const DisplayRealizedGlSwitch = props => {
  const dispatch = useDispatch();
  const checked = useSelector(
    selectSelectedIsDisplayRgl(SelectionState.UNCOMMITTED)
  );

  const onChange = React.useCallback(
    isDisplayRgl => dispatch(setIsDisplayRgl(isDisplayRgl)),
    [dispatch]
  );

  return <Switch label="Show Realized Gain/Loss" 
                 value={checked} 
                 onChange={onChange}
                 raised
        />;
};

DisplayRealizedGlSwitch.propsTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DisplayRealizedGlSwitch;
